import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import 'video.js/dist/video-js.css'
import VueYoutube from 'vue-youtube'
import VueSilentbox from 'vue-silentbox'
import VueCookies from 'vue-cookies'
import Breadcrumbs from '@/partials/breadcrumb'
import HomeBackBtns from '@/partials/home-back-buttons'


import App from './App.vue'

import store from './store'
import router from './router'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(VueYoutube)
Vue.use(VueSilentbox)
Vue.use(VueCookies)
Vue.component('Breadcrumbs', Breadcrumbs)
Vue.component('HomeBackBtns', HomeBackBtns)

Vue.$cookies.config('7d')
Vue.config.productionTip = false
export const bus = new Vue()
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
